import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFundsAllocationIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 25,
	viewBox: "0 0 21 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.8477 6.86182H3.54762C1.86447 6.86182 0.5 8.22628 0.5 9.90943V21.205C0.5 22.8881 1.86446 24.2526 3.54762 24.2526H16.5822C18.2654 24.2526 19.6299 22.8881 19.6299 21.205V9.90944C19.6299 8.22628 18.2654 6.86182 16.5822 6.86182H10.0649",
			stroke: "#91624A",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.8179 7.10547L14.8179 24.2131",
			stroke: "#91624A",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.45703 1.25269V16.0348",
			stroke: "#91624A",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.87337 3.76799L6.91828 0.723074C7.21583 0.425532 7.69824 0.425531 7.99578 0.723074L11.0407 3.76799",
			stroke: "#91624A",
			strokeLinecap: "round"
		})
	]
});
export default SvgFundsAllocationIcon;
